import React from 'react';
import { RichTableState } from './types';

export type UseResetSelectionArgs = {
    state: RichTableState;
    onStateChange: (newState: RichTableState) => void;
    data: any[];
};

export const useResetSelection = ({ state, onStateChange, data }: UseResetSelectionArgs) => {
    const clearSelection = () => {
        onStateChange({ ...state, selectedRowKeys: [] });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    React.useEffect(clearSelection, [data]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    React.useEffect(clearSelection, [JSON.stringify(state.columnFilters)]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    React.useEffect(clearSelection, [state.searchValue]);
};
